import React from "react";

class Download extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <section
          className="download-section pt-100 background-img"
          style={{
            backgroundImage: "url('img/app-hero-bg.jpg')",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "cover"
          }}
        >
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7">
                <div className="download-content text-white pb-100">
                  <h2 className="text-white">
                  iCurrency
                  </h2>
                  <p className="lead">
                  The easiest way to get the live exchange rates of over 170 currencies and over 100 cryptocurrencies for free right on your smartphone or tablet.
                  </p>
                  <div className="download-btn">
                    <a href="https://play.google.com/store/apps/details?id=com.currencyapp" target="_blank" className="btn google-play-btn mr-3">
                      <span className="ti-android"></span> Google Play
                    </a>
                    <a href="https://apps.apple.com/app/id1440368328" target="_blank" className="btn app-store-btn">
                      <span className="ti-apple"></span> App Store
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="download-img d-flex align-bottom">
                  <img
                    src="img/app-hand-top.png"
                    alt="download"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
          <div style={{height: 80}}/>
        </section>
      </React.Fragment>
    );
  }
}

export default Download;
